





































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { userModule } from "@/store/modules/user";
import CatatanPemberianObatStore from "@/store/modules/CatatanPemberianObat";
import CpoDosisModal from "@/components/modal/CpoDosisModal.vue";
import CpoPemberianModal from "@/components/modal/CpoPemberianModal.vue";
import CpoRekapModal from "@/components/modal/CpoRekapModal.vue";
import SvcCatatanPemberianObat from "@/services/CatatanPemberianObat";
import { LIMA_BENAR } from "@/constants/cpoLimaBenar";

@Component({
  components: {
    CpoDosisModal,
    CpoPemberianModal,
    CpoRekapModal
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CatatanPemberianObatPage extends Vue {
  @Prop() readonly register;
  @Prop() readonly rm;
  @Prop() disabled: boolean;
  @Prop() modal: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  modalDosis = false;
  modalPemberian = false;
  modalRekap = false;
  groupByRute = true;
  tipe = "";
  dataCpo: object = {};
  dataPemberian: object = {};
  dataRekap = [];
  loadingRekap = false;
  verifikator = null;

  // Obat hasil resep yang belum punya baris Catatan Pemberian Obat.
  pendingReadback: any[] = [];
  showPending = false;
  limaBenar = LIMA_BENAR;
  autoGenerating = false;

  mounted() {
    this.reloadAll();
  }

  get stateUser() {
    return userModule.user;
  }

  get currentRegister() {
    return RegisterKunjungan.register;
  }

  get cpoList() {
    return this.mapData(CatatanPemberianObatStore.dataList);
  }

  get loading() {
    return CatatanPemberianObatStore.loading;
  }

  get headers() {
    const baseHeaders = [
      {
        text: "No",
        value: "index",
        sortable: false,
        width: "35px",
        class: "sticky-col col-1",
        cellClass: "sticky-col col-1"
      },
      {
        text: "Nama Obat",
        value: "namaObat",
        sortable: false,
        width: "270px",
        class: "sticky-col col-2",
        cellClass: "sticky-col col-2"
      },
      {
        text: "Dosis",
        value: "dosis",
        sortable: false,
        width: "100px",
        class: "sticky-col col-3",
        cellClass: "sticky-col col-3"
      },
      {
        text: "Rute",
        value: "rute",
        sortable: false,
        width: "100px",
        class: "sticky-col col-4",
        cellClass: "sticky-col col-4"
      },
      {
        text: "Jadwal",
        value: "jadwal",
        sortable: false,
        width: "100px",
        class: "sticky-col col-5",
        cellClass: "sticky-col col-5"
      }
    ];

    if (!this.currentRegister || !this.currentRegister.tgl) {
      return baseHeaders;
    }
    const [dd, mm, yyyy] = this.currentRegister.tgl.split("-");
    // const start = new Date(`${yyyy}-${mm}-${dd}`);
    const start = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
    start.setHours(0, 0, 0, 0);

    let end;
    if (this.currentRegister.dout) {
      const [d2, m2, y2] = this.currentRegister.dout.split("-");
      // end = new Date(`${y2}-${m2}-${d2}`);
      end = new Date(Number(y2), Number(m2) - 1, Number(d2));
      end.setHours(0, 0, 0, 0);
    } else {
      end = new Date();
      end.setHours(0, 0, 0, 0);
    }

    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return baseHeaders;
    }

    const dateCols = [];
    const current = new Date(end);

    while (current >= start) {
      const y = current.getFullYear();
      const m = String(current.getMonth() + 1).padStart(2, "0");
      const d = String(current.getDate()).padStart(2, "0");
      const dateStr = `${y}-${m}-${d}`;

      dateCols.push({
        text: `${d}/${m}/${y}`,
        value: `${dateStr}`,
        sortable: false,
        width: "150px",
        class: "text-center",
        cellClass: "text-center"
      });

      current.setDate(current.getDate() - 1);
    }

    return [...baseHeaders, ...dateCols];
  }

  async getByRegister() {
    this.loadingRekap = false;
    await CatatanPemberianObatStore.getByRegister(this.register).then(() => {});
  }

  reloadAll() {
    this.getByRegister();
    this.getPendingReadback();
  }

  async getPendingReadback() {
    try {
      const resp = await SvcCatatanPemberianObat.pendingReadback(this.register);
      this.pendingReadback = resp && resp.data ? resp.data : [];
    } catch (e) {
      this.pendingReadback = [];
    }
  }

  async autoGenerateCpo() {
    if (this.autoGenerating) return;
    this.autoGenerating = true;
    try {
      const resp = await SvcCatatanPemberianObat.autoGenerate(this.register);
      appModule.sendSuccessNotice(
        resp.message || "Catatan Pemberian Obat dibuat otomatis dari resep"
      );
      this.reloadAll();
    } finally {
      this.autoGenerating = false;
    }
  }

  mapData(rawData) {
    return rawData.map(item => {
      const mapTanggal = {};

      item.pemberian.forEach(p => {
        if (!mapTanggal[p.date]) {
          mapTanggal[p.date] = [];
        }
        mapTanggal[p.date].push(p);
      });

      return {
        ...item,
        // fallback bila baris lama belum punya kategori dari backend
        rute_kategori_sort:
          item.rute_kategori_sort || "9. Lain-lain / Belum Ditentukan",
        pemberianMap: mapTanggal
      };
    });
  }

  // Hilangkan prefix angka pengurut ("1. Oral ..." -> "Oral ...")
  groupLabel(group: string) {
    return group ? group.replace(/^\d+\.\s*/, "") : "Lain-lain";
  }

  rowClass(item) {
    if (item.stopped_at) {
      return "grey-row";
    } else {
      if (item.ham_lasa == "1") {
        return "red-row";
      } else if (item.ham_lasa == "2") {
        return "yellow-row";
      } else {
        return "white-row";
      }
    }
  }

  rekap() {
    if (!this.loadingRekap) {
      this.loadingRekap = true;
      SvcCatatanPemberianObat.getRekap(this.register)
        .then(resp => {
          if (resp.status == 1) {
            this.dataRekap = resp.data;
            this.modalRekap = true;
          } else {
            appModule.sendErrorAlert(
              resp.message ||
                "Tidak ada transaksi obat farmasi untuk direkap pada kunjungan ini"
            );
          }
        })
        .finally(() => {
          this.loadingRekap = false;
        });
    }
  }

  printMAR() {
    SvcCatatanPemberianObat.printMAR(this.register);
  }

  addDosis(item, type: string) {
    this.tipe = "";
    this.dataCpo = {
      cpo_item_id: item.cpo_item_id,
      nama_obat: item.nama,
      rute_dokter: item.resep_rute,
      resep_obat_id: item.resep_obat_id,
      resep_rute_id: item.resep_rute_id,
      resep_rute: item.resep_rute,
      resep_dosis: item.resep_dosis,
      resep_frekuensi_id: item.resep_frekuensi_id,
      dr_id: item.dr_id,
      kd_obat: item.kode_obat,
      disp_qty: item.total_qty,
      unit_id: item.unit_id,
      keterangan: item.keterangan,
      dosis: item.dosis,
      rute: item.rute,
      jadwal: item.jadwal,
      r: item.r
    };
    this.tipe = type;
    this.modalDosis = true;
  }

  addPemberian(item, tgl: string) {
    this.verifikator = null;
    this.dataPemberian = {
      id: null,
      cpo_item_id: item.cpo_item_id,
      nama_obat: item.nama,
      ham_lasa: item.ham_lasa,
      dr_id: item.dr_id,
      kd_obat: item.kode_obat,
      unit_id: item.unit_id,
      dosis: item.dosis,
      rute: item.rute,
      jadwal: item.jadwal,
      tgl: tgl,
      time: null,
      verified_at: null
    };

    this.modalPemberian = true;
  }

  async stopStart(id, status) {
    const dt = {
      stopped: status
    };
    SvcCatatanPemberianObat.stopStartPemberian(id, dt)
      .then(resp => {
        if (resp.status == 1) {
          if (status == 1) {
            appModule.NoticeDelay("Berhasil Stop pemberian obat");
          } else {
            appModule.NoticeDelay("Berhasil Lanjutkan pemberian obat");
          }
          this.getByRegister();
        } else {
          appModule.sendErrorAlert(resp.message);
        }
      })
      .finally(() => {});
  }

  limaBenarTercatat(pemberian): boolean {
    return this.limaBenar.some(
      b => pemberian[b.key] !== null && pemberian[b.key] !== undefined
    );
  }

  jumlahBenar(pemberian): number {
    return this.limaBenar.filter(b => !!pemberian[b.key]).length;
  }

  ubahPemberian(item, cpo_item, tgl) {
    this.verifikator = item.verifikator ? item.verifikator.id : null;
    this.dataPemberian = {
      id: item.id,
      cpo_item_id: cpo_item.cpo_item_id,
      nama_obat: cpo_item.nama,
      ham_lasa: cpo_item.ham_lasa,
      rute: cpo_item.rute,
      dr_id: cpo_item.dr_id,
      kd_obat: cpo_item.kode_obat,
      unit_id: cpo_item.unit_id,
      dosis: item.dosis_text,
      jadwal: cpo_item.jadwal,
      tgl: tgl,
      time: item.time,
      verified_at: item.verified_at,
      benar_pasien: item.benar_pasien,
      benar_obat: item.benar_obat,
      benar_dosis: item.benar_dosis,
      benar_waktu: item.benar_waktu,
      benar_rute: item.benar_rute
    };
    this.modalPemberian = true;
  }

  replaceDosis(data) {
    CatatanPemberianObatStore.PATCH_ITEM(data);
  }

  tambahPemberian(data) {
    CatatanPemberianObatStore.ADD_PEMBERIAN(data);
  }

  replacePemberian(data) {
    CatatanPemberianObatStore.PATCH_PEMBERIAN(data);
  }

  hapusPemberian(data) {
    CatatanPemberianObatStore.REMOVE_PEMBERIAN(data);
  }
}
